import gql from "graphql-tag";

export const ALL_AUTOMATED_STATEMENTS = gql`
    query ALL_AUTOMATED_STATEMENTS($page: Int!, $perPage: Int!, $searchKeyword: String){
        scheduledStatementOrders (page: $page, perPage: $perPage, searchKeyword: $searchKeyword) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                order {
                    publicId,
                    invoiceId,
                    deliveryDate,
                    createdAt
                    orderedBy
                    grossOrderTotal
                    paymentDueDate
                },
                customerId {
                    publicId,
                    name,
                    createdAt
                },
                createdAt
            }
        }
    }
`;

export const ALL_PROCESSED_EMAILS= gql`
    query ALL_PROCESSED_EMAILS($page: Int!, $perPage: Int!, $searchKeyword: String){
        processedStatementEmails (page: $page, perPage: $perPage, searchKeyword: $searchKeyword) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                customerId {
                    publicId,
                    name
                },
                statementNumber,
                createdAt
                emailTo,
                emailFrom,
                emailDeliveryStatus,
                orders {
                    publicId,
                    invoiceId,
                    createdAt,
                    grossOrderTotal,
                    netOrderTotal,
                    createdAt,
                    lastUpdatedBy {
                        publicId,
                        name
                    }
                },
                attempts {
                    emailDeliveryStatus,
                    emailDeliveryDatetime
                }
            }
        }
    }
`;

export const SINGLE_PROCESSED_EMAIL= gql`
    query SINGLE_PROCESSED_EMAIL($id: String!){
        processedStatementEmail (id: $id) {
            publicId,
            customerId {
                publicId,
                name
            },
            statementNumber,
            createdAt
            emailTo,
            emailFrom,
            emailDeliveryStatus,
            orders {
                publicId,
                invoiceId,
                deliveryDate,
                grossOrderTotal,
                netOrderTotal,
                orderedBy
                paymentStatus{
                    name
                }
                paymentDueDate
            },
            attempts {
                emailDeliveryStatus,
                emailDeliveryDatetime
            }
        }
    }
`;
